// Which Out-Of-Target reasons a step's picker offers (sla.md). A reason
// carries the steps it was written for (column_keys, from 1.0's catalogue);
// one with none listed is offered everywhere.
export function reasonsForStep(reasons, columnKey) {
  return (reasons || []).filter((r) => {
    const keys = Array.isArray(r.column_keys) ? r.column_keys : [];
    return keys.length === 0 || !columnKey || keys.includes(columnKey);
  });
}
